var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFlagAustralia(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_651_2894)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 0H0V24H24V0Z",
    fill: "#000066"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0V1.31019L14.3923 11.7187H16.2039V10.4086L1.8116 3.90623e-05L0 0ZM16.2039 0V1.31015L1.8116 11.7187H0V10.4086L14.3923 0H16.2039Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.75164 0V11.7187H9.4523V0H6.75164ZM0 3.90623V7.81247H16.2039V3.90623H0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 4.68748V7.03122H16.2039V4.68748H0ZM7.29177 0V11.7187H8.91217V0H7.29177Z",
    fill: "#CC0000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 11.7187L5.40131 7.81247H6.60905L1.20773 11.7187H0ZM0 0L5.40131 3.90623H4.19358L0 0.873473L0 0ZM9.59489 3.90623L14.9962 0H16.2039L10.8026 3.90623H9.59489ZM16.2039 11.7187L10.8026 7.81247H12.0104L16.2039 10.8453V11.7187Z",
    fill: "#CC0000"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.57284 17.28L4.47903 18.0018L5.10339 16.0611L5.72776 18.0018L7.63394 17.28L6.50606 18.978L8.25903 20.0184L6.22804 20.195L6.50786 22.2145L5.10339 20.7367L3.69893 22.2145L3.97874 20.195L1.94775 20.0184L3.70073 18.978L2.57284 17.28Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.9285 22.3319L18.0462 22.4086L18.168 23.2857L17.5577 22.6439L16.9474 23.2857L17.0691 22.4086L16.1868 22.3319L16.9483 21.8797L16.4581 21.1421L17.2866 21.4558L17.5577 20.6125L17.8287 21.4558L18.6572 21.1421L18.167 21.8797L18.9285 22.3319Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.9285 9.20704L18.0462 9.28382L18.168 10.1609L17.5577 9.51909L16.9474 10.1609L17.0691 9.28382L16.1868 9.20704L16.9483 8.75496L16.4581 8.01725L17.2866 8.33093L17.5577 7.48779L17.8287 8.33093L18.6572 8.01725L18.167 8.75496L18.9285 9.20704Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.0067 14.539L13.1244 14.6158L13.2461 15.4929L12.6358 14.851L12.0255 15.4929L12.1472 14.6158L11.2649 14.539L12.0265 14.0869L11.5362 13.3492L12.3648 13.6629L12.6358 12.8197L12.9068 13.6629L13.7353 13.3492L13.2451 14.0869L14.0067 14.539Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.303 13.2265L22.4203 13.3033L22.5417 14.1804L21.9314 13.5386L21.3211 14.1804L21.4425 13.3033L20.5615 13.2265L21.3244 12.7744L20.8332 12.0368L21.6624 12.3504L21.9314 11.5072L22.2038 12.3504L23.0306 12.0368L22.5417 12.7744L23.303 13.2265Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.5264 16.6413L19.044 16.9402L19.1795 16.3893L18.7461 16.0234L19.3121 15.9817L19.5264 15.4564L19.7406 15.9817L20.3066 16.0234L19.8732 16.3893L20.0087 16.9402L19.5264 16.6413Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_651_2894"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 2,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagAustralia);
export default __webpack_public_path__ + "static/media/flag_australia.f35f1f5b71181d9a9724a3b3642c218f.svg";
export { ForwardRef as ReactComponent };